var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.72 1.85h.654v1.252c0 1.741 2.558 1.741 2.558 0V1.85h4.136v1.252c0 1.741 2.558 1.741 2.558 0V1.85h.707a2.416 2.416 0 012.395 2.395v9.306c0 1.306-1.089 2.449-2.395 2.449H2.721C1.36 16 .272 14.857.272 13.55V4.246c0-1.306 1.088-2.395 2.449-2.395zM5.55.925v2.177c0 1.197-1.795 1.197-1.795 0V.925c0-1.252 1.796-1.252 1.796 0zm4.899 0v2.177c0 1.197 1.796 1.197 1.796 0V.925c0-1.252-1.796-1.252-1.796 0zm4.626 5.606H.925v7.02c0 .98.817 1.742 1.796 1.742h10.613c.925 0 1.741-.762 1.741-1.742v-7.02z",
    fill: "#292929"
  })));
}
export default SvgIconCalendar;